import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onOpenDevicePermissionsDialog = action('onOpenDevicePermissionsDialog', event => ({
    event,
    owaType: 'permissionsDialog',
})) as OwaNovaActionUnion<'permissionsDialog'>;

export const onSaveDevicePermissions = action('onSaveDevicePermissions', event => ({
    event,
    owaType: 'permissionsDialogSave',
})) as OwaNovaActionUnion<'permissionsDialogSave'>;

export const onCloseDevicePermissions = action('onCloseDevicePermissions', event => ({
    event,
    owaType: 'permissionsDialogClose',
})) as OwaNovaActionUnion<'permissionsDialogClose'>;
